module.exports = __webpack_public_path__ + "img/jidian_guandaozuli.8afadccf.png";